import React from "react";

const BtnLink = (props) => {
    return(
        <a href={props.link} type="button" target="_blank"><span>{props.title}</span></a>
    )
}

export default BtnLink;